import { render, staticRenderFns } from "./RevisionCompare.vue?vue&type=template&id=5c1f008a&scoped=true"
import script from "./RevisionCompare.vue?vue&type=script&lang=js"
export * from "./RevisionCompare.vue?vue&type=script&lang=js"
import style0 from "./RevisionCompare.vue?vue&type=style&index=0&id=5c1f008a&prod&scoped=true&lang=css"
import style1 from "./RevisionCompare.vue?vue&type=style&index=1&id=5c1f008a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1f008a",
  null
  
)

export default component.exports